import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaInformacionFechapagoEditar', {
    template: template,
    controller: NominasNominaInformacionFechapagoEditarComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      fechaNomina: '<',
      data: '<',
      onChange: '&',
      onClose: '&',
    },
  })

function NominasNominaInformacionFechapagoEditarComponent(NominasNominaInformacionFechapago, $filter) {
  let $ctrl = this

  $ctrl.$onChanges = $onChanges
  $ctrl.guardar = guardar
  $ctrl.cancelar = cancelar
  $ctrl.validar = validar

  function $onChanges(changes) {
    if (changes.data)
      $ctrl.data = angular.copy(changes.data.currentValue)

    validar()
  }

  function cancelar() {
    $ctrl.onClose()
  }

  function guardar() {
    $ctrl.guardando = true

    return NominasNominaInformacionFechapago.put($ctrl.idProyecto, $ctrl.idNomina, {fecha_pago: $ctrl.data})
      .then(function () {
        $ctrl.onChange({$event: {data: $ctrl.data}})
      })
      .finally(function () {
        $ctrl.guardando = false
      })
  }

  function validar() {
    let diffDays = Math.ceil(($ctrl.data.getTime() - $ctrl.fechaNomina.getTime()) / (1000 * 3600 * 24))

    if (Math.abs(diffDays) > 5)
      $ctrl.alerta = 'La fecha de pago es ' + Math.abs(diffDays) + ' días '
        + (diffDays > 0 ? 'mayor' : 'menor')
        + ' a la fecha de la nómina '
        + $filter('date')($ctrl.fechaNomina, 'dd/MM/yyyy')
    else
      $ctrl.alerta = null
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/fechapago/editar/component.js